import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useCategoryTableView } from "~/features/admin/categories/hooks";
import { formatCategoryHierarchy } from "~/features/admin/categories/utils/transformers";
import { CategoryHierarchyTable } from "./CategoryHierarchyTable";

interface CategoryHierarchyTabProps {
  categoryType: "entity" | "relation";
  onSelect: (id: string) => void;
}

/** Thin container for the entity/relation hierarchical table tabs. */
export function CategoryHierarchyTab({ categoryType, onSelect }: CategoryHierarchyTabProps) {
  const { t } = useTranslation();
  const { data } = useCategoryTableView(categoryType);
  const rows = useMemo(() => formatCategoryHierarchy(data.categories), [data.categories]);

  return (
    <CategoryHierarchyTable
      rows={rows}
      categoryType={categoryType}
      onSelect={onSelect}
      emptyMessage={t("feature.categories.empty")}
    />
  );
}
